import type { FC } from "react";
import { AgGridReact, type AgGridReactProps } from "ag-grid-react";
import { useAgGridLocale, useAgGridTheme } from "../hooks/table.js";

export const AgGridTable: FC<AgGridReactProps> = ({ ...props }) => {
  const locale = useAgGridLocale();
  const theme = useAgGridTheme();
  return <AgGridReact localeText={locale} theme={theme} {...props} />;
};
